// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh3[data-v-df02a584] {\n  margin: 40px 0 0;\n}\nul[data-v-df02a584] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-df02a584] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-df02a584] {\n  color: #42b983;\n}\n.v-alert[data-v-df02a584] {\n margin: 5%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
